import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { createUseStyles, useTheme } from 'react-jss';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles = createUseStyles(function (theme) {
  var palette = theme.palette,
      radius = theme.radius,
      shadow = theme.shadow;
  var button = {
    borderRadius: radius.small,
    boxShadow: shadow.none
  };
  var buttonOverrides = {
    '&:first-of-type': {
      borderTopLeftRadius: button.borderRadius,
      borderBottomLeftRadius: button.borderRadius
    },
    '&:last-of-type': {
      borderTopRightRadius: button.borderRadius,
      borderBottomRightRadius: button.borderRadius
    },
    // Add borders between each button unless the buttons are ghost buttons
    // since ghosts already have borders designed into them
    '&:not(.wrenchButton--ghost):not(:first-of-type)': {
      borderLeft: [1, 'solid', palette.background.light]
    },
    // Remove the left border on ghosts because if not borders
    // will double up and optically be 2px between each button
    '&.wrenchButton--ghost:not(:first-of-type)': {
      borderLeft: 'none'
    }
  };
  var radioVariant = {
    '&:not(.wrenchButton--ghost):not(:first-of-type)': {
      borderLeftWidth: 0
    }
  };
  return {
    wrenchButtonGroup: function wrenchButtonGroup(_ref) {
      var radio = _ref.radio;
      return {
        display: 'inline-flex',
        boxShadow: button.boxShadow,
        borderRadius: button.borderRadius,
        '& [class*="wrenchButton"]': _objectSpread(_objectSpread({
          borderRadius: 0,
          boxShadow: 'none'
        }, buttonOverrides), radio && radioVariant)
      };
    }
  };
});
var _excluded = ["radio", "children"];

var ButtonGroup = function ButtonGroup(_ref) {
  var radio = _ref.radio,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();

  var _useStyles = useStyles({
    radio: radio,
    theme: theme
  }),
      wrenchButtonGroup = _useStyles.wrenchButtonGroup;

  return /*#__PURE__*/React.createElement("div", Object.assign({
    role: "group",
    className: wrenchButtonGroup
  }, safeRest(props)), children);
};

ButtonGroup.displayName = "ButtonGroup";
ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,

  /**
   * Set to true if the ButtonGroup will be used similar to a radio or tab component.
   */
  radio: PropTypes.bool
};
ButtonGroup.defaultProps = {
  radio: false
};
ButtonGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ButtonGroup",
  "props": {
    "radio": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to true if the ButtonGroup will be used similar to a radio or tab component."
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};
export { ButtonGroup };